<template>
  <div v-loading="loading" class="log-wrapper">
    <div class="personnel-manage">
      <Top title="人员管理">
        <template #btn-bar>
          <el-button type="primary" @click="handleShowEditDialog()">添加人员</el-button>
        </template>
      </Top>
      <!-- 表格 -->
      <el-table ref="table"
                :data="tableData" class="table" empty-text="暂无数据">
        <el-table-column label="姓名" prop="realName" min-width="200px">
          <template v-slot="scope">
            <div class="row-name">
              <div class="name">{{ scope.row.realName }}</div>
              <el-tag v-if="scope.row.managerFlag" effect="plain" type="warning" class="manager">
                管理员
              </el-tag>
              <div v-else class="set-manager">
                <el-button v-if="userInfo.managerFlag" type="text" class="set-manager" @click="handleSetManager(scope.row.id)">设为管理员</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="phoneNumber" min-width="150px"></el-table-column>
        <el-table-column label="职位" prop="userPosition" min-width="150px"></el-table-column>
        <el-table-column label="操作" width="200px">
          <template v-if="userInfo.managerFlag" v-slot="scope">
            <el-button type="text" @click="handleShowEditDialog(scope.row.id)">编辑</el-button>
            <el-button type="text" @click="handleResetPwd(scope.row.id)">重置密码</el-button>
            <el-button v-if="!scope.row.managerFlag" type="text" style="color: #D62222;" @click="handleDel(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-sizes="[15, 20, 30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
      <EditDialog v-if="editDialogShow" :id="editId" @close="handleCloseEditDialog"></EditDialog>
    </div>
  </div>
</template>

<script>
import ListMixin from 'src/views/mixins/list'
import Top from '@/components/common/tableTop'
import EditDialog from './dialog/editDialog'
import { mapGetters } from 'vuex'
import {
  getPersonnelListApi,
  delPersonnelApi,
  resetPersonnelPWDApi,
  setPersonnelManagerApi,
} from './fetch'
export default {
  name: 'PersonnelManage',
  components: {
    Top,
    EditDialog,
  },
  mixins: [ListMixin],
  data () {
    return {
      getListApi: getPersonnelListApi,
      editId: '',
      editDialogShow: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    handleResetPwd (id) {
      this.$confirm('确定重置该用户的登录密码吗？重置登录密码为123456，重置后请联系该用户及时登录系统，并更新初始密码！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await resetPersonnelPWDApi(id)
        this.$success('操作成功！')
        this.handleSearch()
      }).catch((e) => {
        if (e !== 'cancel') {
          this.$error(e)
        }
      })
    },
    handleDel (id) {
      this.$confirm('确定删除该人员吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await delPersonnelApi(id)
        this.$success('删除成功！')
        this.handleSearch()
      }).catch((e) => {
        if (e !== 'cancel') {
          this.$error(e)
        }
      })
    },
    handleSetManager (id) {
      this.$confirm('确定更换该员工为管理员吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await setPersonnelManagerApi(id)
        this.$success('操作成功！')
        // this.handleSearch()
        location.reload()
      }).catch((e) => {
        if (e !== 'cancel') {
          this.$error(e)
        }
      })
    },
    handleShowEditDialog (id) {
      this.editId = id
      this.editDialogShow = true
    },
    handleCloseEditDialog (refresh) {
      this.editId = ''
      this.editDialogShow = false
      if (refresh) {
        this.handleSearch()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.log-wrapper{
  overflow: auto;
}
.personnel-manage{
  padding: 0 40px 40px;
  .row-name{
    display: flex;
    align-items: center;
    width: 100%;
    &:hover{
      .set-manager{
        display: inline-block;
      }
    }
    .name{
      margin-right: 20px;
      min-width: 50px;
    }
    .manager{
      border-color: #FF9114;
      color: #FF9114;
    }
    .set-manager{
      display: none;
    }
  }
}

</style>
